module.exports = window["MaterialUI"].ExpansionPanelSummary;